// Main JavaScript entry point (production bundle; styles linked in index.html)
console.log('Application initialized');

// Cookie Consent Manager initialization
document.addEventListener('DOMContentLoaded', function() {
  const cookieBanner = document.getElementById('cookieConsent');
  if (!cookieBanner) return;

  console.log('Cookie consent manager initialized');

  const acceptAllBtn = document.getElementById('cookieAcceptAll');
  const settingsBtn = document.getElementById('cookieSettings');
  const cookieModal = document.getElementById('cookieModal');
  const closeModalBtn = document.getElementById('closeModal');
  const saveSettingsBtn = document.getElementById('saveCookieSettings');
});
